module.exports = __webpack_public_path__ + "static/media/face.54004ec4.webp";